(ns nosco.graphql.errors)

(defn make-error
  "Create a standard error map to be returned by a GraphQL response."
  ([type msg] (make-error type msg nil))
  ([type msg map] (assoc map :message msg :type (name type))))

(defn ->exception
  "Convert an error into a `clojure.lang.ExceptionInfo`."
  [error]
  (ex-info (:message error) (dissoc error :message)))

(defn unauthorized-error
  ([] (unauthorized-error nil))
  ([map] (make-error :unauthorized "Unauthorized"
                     (merge {:status 403} map))))

(defn duplicate-error
  ([] (duplicate-error nil))
  ([map] (make-error :duplicate "Duplicate" (merge {:status 409} map))))

(defn conflict-error
  ([msg] (conflict-error msg nil))
  ([msg map] (make-error :conflict msg (merge {:status 409} map))))

(defn not-found-error
  ([] (not-found-error nil))
  ([map] (make-error :not-found "Not found"
                     (merge {:status 404} map))))

(defn bad-argument-error
  ([msg] (bad-argument-error msg nil))
  ([msg map] (make-error :bad-argument msg (assoc map :status 400))))

(defn response-errors
  "Returns a seq of errors from a GraphQL response, or nil when there are no matching errors.
  Can optionally filter by the error type key, e.g. :duplicate, and by other keys present in
  the extensions map of the error by passing filters as a map."
  ([response] (seq (:errors response)))
  ([response type] (response-errors response type nil))
  ([response type filters]
   (let [filters (assoc filters :type (name type))]
     (seq (filter #(= filters (select-keys (:extensions %) (keys filters))) (:errors response))))))
